/*
 * @Author: vinc
 * @LastEditTime: 2020-12-29 11:45:23
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueCookies from 'vue-cookies'
import store from './store'
import './registerServiceWorker'
import './common/filter'
import install from './common/install'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import JsonExcel from 'vue-json-excel';
import $https from "./common/http";
Vue.component('downloadExcel', JsonExcel);
Vue.use(VueCookies);
Vue.use(install);

export let bmsAsyncTask = "/bms-async-task";

if (process.env.NODE_ENV == 'development') {
    var url = "https://testbms.qx.com/bms-web"
    //var url = "http://172.19.26.132:808/bms-web" //本地 mx
    let webUrl = process.env.VUE_APP_WEB_URL;
    if(webUrl){
        url = webUrl; //编程工具设置的环境变量
    }
    // var url = "http://localhost:808/bms-web"
    // Vue.prototype.downExcelUrl = 'http://172.19.26.129:808/bms-web' //本地lyj
    // Vue.prototype.downExcelUrl = 'http://172.19.26.132:808/bms-web' //本地mx
    //Vue.prototype.downExcelUrl = 'http://192.168.1.14:8081/bms-web' //本地 bb
    // Vue.prototype.downExcelUrl = 'http://172.18.68.177:8080/bms-web' //本地 bb
    // Vue.prototype.downExcelUrl = url //本地 bb
    Vue.prototype.bestSignUrl = "https://ent.bestsign.info/"
    Vue.prototype.fddUrl = 'http://172.17.3.119/#/login';
    Vue.prototype.qxmOss = 'https://qxm.oss-cn-shenzhen.aliyuncs.com/dev/bms/' //测试3
    Vue.prototype.wxLogin = {
        appid: 'ww4fe97bad6034587c',
        agentid: '1000014',
    }
    if (
        Vue.prototype.downExcelUrl && Vue.prototype.downExcelUrl.includes("//172") ||
        Vue.prototype.downExcelUrl && Vue.prototype.downExcelUrl.includes("//127") ||
        Vue.prototype.downExcelUrl && Vue.prototype.downExcelUrl.includes("//localhost") ||
        $https && $https.defaults && $https.defaults.url && $https.defaults.url.includes("//172") ||
        $https && $https.defaults && $https.defaults.url && $https.defaults.url.includes("//127")
    ) {
        bmsAsyncTask = "";
    }
    bmsAsyncTask = "";
    Vue.prototype.downExcelUrl = url +bmsAsyncTask //测试环境
} else {
    Vue.prototype.bestSignUrl = "https://ent.bestsign.cn/"
    Vue.prototype.fddUrl = 'https://sign.qx.com/#/login'
    // Vue.prototype.downExcelUrl = 'http://172.17.6.183:8080/bms-web' //测试
    // Vue.prototype.downExcelUrl = 'https://172.17.3.68:8080/bms-web'  // 生产
    Vue.prototype.downExcelUrl = 'https://bms.qx.com:8080/bms-web'+bmsAsyncTask  // 生产1
    // Vue.prototype.downExcelUrl = 'http://172.17.6.180:8080/bms-web' //测试80
    // Vue.prototype.downExcelUrl = 'https://172.17.6.182:8085/bms-web' //测试82
    Vue.prototype.qxmOss = 'https://qxm.oss-cn-shenzhen.aliyuncs.com/prd/bms/' //测试3
    Vue.prototype.wxLogin = {
        appid: 'wwf7b9737467d43ec5',
        agentid: '1000033',
    }
}

Vue.config.productionTip = false
Vue.use(ElementUI)

if (sessionStorage.getItem("TOKEN")) {
    store.commit('SET_TOKEN', sessionStorage.getItem("TOKEN"))

    // 恢复shouldHideReturnFields状态
    const shouldHide = sessionStorage.getItem("shouldHideReturnFields") === 'true';
    store.commit('SET_SHOULD_HIDE_RETURN_FIELDS', shouldHide);

    store.dispatch("getTopLists", 1);
    store.dispatch("getTopLists", 3);
    store.dispatch("getTopLists", 4);
    store.dispatch("getTopLists", 7);
    store.dispatch("getTopLists", 10);
    store.dispatch("getTopLists", 11);
    store.dispatch("getTopLists", 13);
    store.dispatch("getTopLists", 15);
    store.dispatch("getTopLists", 16);
    store.dispatch("getTopLists", 18);
    store.dispatch("getdropdownList", 2);
    store.dispatch("getdropdownList", 4);
    store.dispatch("getdropdownList", 17);
}
router.beforeEach((to, from, next) => {
    if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
        if (sessionStorage.getItem("TOKEN")) {  // 通过vuex state获取当前的token是否存在
            next();
        }
        else {
            next({
                path: '/login',
                // query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
            })
        }
    }
    else {
        next();
    }
})
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
